import * as React from "react"
import { StaticImage } from "gatsby-plugin-image"
import Layout from "../components/layout"
import Seo from "../components/seo"

const HotelPage = () => (
  <Layout>
    <Seo title="CSICon Hotel Information" />
    <div className="row page-row">
      <div className="col-12 col-lg-8">
        <div className="page-header">
          <h1>
            <strong>Plan Your Visit</strong>
          </h1>
          <hr />
        </div>
        <h2><strong>Book Your Stay</strong></h2>
        <StaticImage
          src="../images/BUFFALO-Hotel-Exterior-View.png"
          alt="Buffalo Hyatt Regency"
          height="100%"
          loading="lazy"
          placeholder="tracedSVG"
          className="t-image"
          style={{ width: '500px' }}
        />
        <div className="entry-content conference-max mt-3">
          <p>
            Book your stay for CSICon today at the Hyatt Regency Buffalo, Two Fountain Plaza, Buffalo, NY 14202, US.
          </p>
          <p>
            Discounted rooms are available at the Hyatt Regency Buffalo. Follow the link below to complete your reservation. We recommend booking
            early as our conference rooms sell out.
          </p>
          <p><a href="https://www.hyatt.com/hyatt-regency/en-US/buffa-hyatt-regency-buffalo-hotel-and-conference-center/hotel-info">Frequently Asked Hotel Questions</a></p>
            <a
            href="https://www.hyatt.com/en-US/group-booking/BUFFA/G-CFI6"
            className="btn green-button-outline"
            >
            Book Your Stay Now!
          </a>
          <hr />
          <h4>Additional Hotels</h4>          
              <p>
              <strong>Hampton Inn & Suites Buffalo Downtown  (15 Rooms: 6/10 to 6/14)</strong>
              </p>
              <p>
              220 Delaware Avenue
              </p>
              <p>
              Buffalo, New York 14202
              </p>
              <p>
              <strong><a href="https://www.hilton.com/en/book/reservation/deeplink/?ctyhocn=BUFDTHX&tid=0633884&groupCode=CHH91J&arrivaldate=2026-06-10&departuredate=2026-06-15&cid=OM,WW,HILTONLINK,EN,DirectLink&fromId=HILTONLINKDIRECT">Hampton Inn & Suites Buffalo Downtown Link </a></strong>
              </p>
              <p>
              <strong>Embassy Suites by Hilton Buffalo (20 Rooms 6/10 to 6/14)</strong>
              </p>
              <p>
              200 Delaware Avenue
              </p>
              <p>
              Buffalo, New York 14202
              </p>
              <p>
              <a href="https://group.embassysuites.com/nh31dy">Embassy Suits Link</a>
              </p>
              <p>
              <strong>Hilton Garden Inn Buffalo Downtown </strong> <strong>(20 Rooms 6/10 to 6/14)</strong>
              </p>
              <p>
              10 Lafayette Square
              </p>
              <p>
              Buffalo, New York 14203
              </p>
              <p>
              <a href="https://group.hiltongardeninn.com/0zbq9h">Hilton Garden Inn Link</a>
              </p>
              <p>
              <strong>Holiday Inn Express & Suites Buffalo Downtown (20 Rooms: 6/10 to 6/14) </strong>
              </p>
              <p>
              601 Main Street, Buffalo, New York 14203
              </p>
              <p>
              <a href="https://www.ihg.com/redirect?path=rates&brandCode=EX&localeCode=en&regionCode=1&hotelCode=BUFMS&checkInDate=10&checkInMonthYear=052026&checkOutDate=14&checkOutMonthYear=052026&_PMID=99801505&GPC=CSI&cn=no&adjustMonth=false&showApp=true&monthIndex=00">Holiday Inn Link</a>
              </p>
        </div>
      </div>
      <div className="col-12 col-lg-8">
       <h2><strong>Conference Location</strong></h2>
        <StaticImage
            src="../assets/Buffalo Convention Center-csicon.jpg"
            alt="Buffalo"
            height="100%"
            loading="lazy"
            placeholder="tracedSVG"
            style={{ width: '500px' }}
          />
        <div className="entry-content conference-max mt-3">
          <p>          
            Buffalo Convention Center 
            <br />
            153 Franklin St, Buffalo, NY 14202, United States
          </p>
          <p>
            <a href="https://buffaloconvention.com/about/faq/">Frequently Asked Convention Questions</a>
          </p>
          <div className="hotel-img-grid">
            <div className="grid-item">
              <h3>Marquee Level Map</h3>
              <StaticImage
                src="https://buffaloconvention.com/wp-content/uploads/marquee-level.jpg"
                alt="Buffalo Convention Center"
                height="100%"
                loading="lazy"
                placeholder="tracedSVG"
              />
            </div>
          </div>
          <a
            href="https://www.google.com/maps/dir//LOCATION%20Buffalo%20Convention%20Center%20153%20Franklin%20St,%20Buffalo,%20NY%2014202,%20United%20States"
            class="btn green-button-outline"
          >
            Find Directions to the Convention Center
          </a>
 <br />
 <br />
          <a href="/registration/" className="btn green-button">
Register Today      </a>
          </div>
        </div>
    </div>
  </Layout>
)

export default HotelPage
